import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../pages/HomePage.vue';
import { apiRequest } from '@/services/api';
const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            title: 'Mary Iglesias | Escribana Pública en Montevideo'
        }
    },
    {
        path: '/propiedades',
        name: 'properties',
        component: () => import('../pages/PropertiesPage.vue'),
        meta: { title: 'Propiedades | Mary Iglesias Escribana' }
    },
    {
        path: '/propiedades/:slug',
        name: 'property-detail',
        component: () => import('../pages/PropertyDetailPage.vue'),
        meta: { title: 'Propiedad | Mary Iglesias Escribana' }
    },
    {
        path: '/admin/ingresar',
        name: 'admin-login',
        component: () => import('../pages/admin/AdminLoginPage.vue'),
        meta: { title: 'Ingresar | Panel de propiedades', admin: true }
    },
    {
        path: '/admin',
        component: () => import('../pages/admin/AdminLayout.vue'),
        meta: { admin: true, requiresAdmin: true },
        redirect: { name: 'admin-properties' },
        children: [
            {
                path: 'propiedades',
                name: 'admin-properties',
                component: () => import('../pages/admin/AdminPropertiesPage.vue'),
                meta: { title: 'Propiedades | Panel de administración', admin: true, requiresAdmin: true }
            },
            {
                path: 'propiedades/nueva',
                name: 'admin-property-new',
                component: () => import('../pages/admin/AdminPropertyFormPage.vue'),
                meta: { title: 'Nueva propiedad | Panel de administración', admin: true, requiresAdmin: true }
            },
            {
                path: 'propiedades/:id/editar',
                name: 'admin-property-edit',
                component: () => import('../pages/admin/AdminPropertyFormPage.vue'),
                meta: { title: 'Editar propiedad | Panel de administración', admin: true, requiresAdmin: true }
            }
        ]
    },
    { path: '/:pathMatch(.*)*', redirect: { name: 'home' } }
];
const router = createRouter({
    history: createWebHistory(),
    routes
});
router.beforeEach(async (to) => {
    if (!to.meta.requiresAdmin && to.name !== 'admin-login')
        return true;
    try {
        const session = await apiRequest('/api/admin/session');
        if (to.name === 'admin-login' && session.authenticated)
            return { name: 'admin-properties' };
        if (to.meta.requiresAdmin && !session.authenticated)
            return { name: 'admin-login', query: { redirect: to.fullPath } };
    }
    catch (_) {
        if (to.meta.requiresAdmin)
            return { name: 'admin-login', query: { redirect: to.fullPath } };
    }
    return true;
});
router.afterEach((to) => {
    if (to.meta?.title) {
        document.title = to.meta.title;
    }
    window.scrollTo({ top: 0 });
});
export default router;
